import {
  RELEASE_2_5_0,
} from './2_5_0.ts';

import type {
  TReleaseHighlightsDefinition,
} from '@/release-highlights/release-highlights.ts';

export const RELEASE_HIGHLIGHTS: TReleaseHighlightsDefinition[] = [
  RELEASE_2_5_0,
];
